import React from 'react';

export default ({ model }) => (
  <div>
    <span>{model.referrer.referralSourceType}</span>
    {model.referrer.referralSourceName && <span>: {model.referrer.referralSourceName}</span>}
  </div>
);
